import { GraphQLField, GraphQLList } from 'graphql';
import { FieldComponentParams } from '@/types/FieldComponent';
import { cloneDeep } from 'lodash';
import ObjectFieldNormalizer from '@/classes/normalizers/field-normalizers/ObjectFieldNormalizer';
import ListObjectFieldNormalizer from '@/classes/normalizers/field-normalizers/ListObjectFieldNormalizer';
import ObjectFieldFactory from './ObjectFieldFactory';

export default class ListObjectFieldFactory extends ObjectFieldFactory {
  support(field: GraphQLField<any, any, any>): boolean {
    const { type } = field;

    return this.typeInspector.isListType(type) && super.supportType(type.ofType);
  }

  createComponent(params: FieldComponentParams) {
    const componentsParams = cloneDeep(params);
    const normalizer = new ListObjectFieldNormalizer(new ObjectFieldNormalizer());
    const type = (params.field.type as GraphQLList<any>).ofType;
    componentsParams.field = {
      ...componentsParams.field,
      type,
    };

    componentsParams.props = {
      ...componentsParams.props,
      multiple: true,
      normalizer,
    };

    return super.createComponent(componentsParams);
  }
}
